import { type Media, type Image, Emoji } from '@tribeplatform/gql-client/types'

export const isImage = (media: Media): media is Image => {
  if (!media) {
    return false
  }

  if ('urls' in media || 'url' in media) {
    return true
  }

  return false
}

export const isEmoji = (media: Media): media is Emoji => {
  if (!media) {
    return false
  }

  if ('text' in media && !('variant' in media)) {
    return true
  }

  return false
}

export const isGlyph = (media: Media): media is Emoji => {
  if (!media) {
    return false
  }

  if ('text' in media && 'variant' in media) {
    return true
  }

  return false
}
